import {Component, OnInit} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {Permission} from 'jugacu-lib';
import {WhistlerAPIService} from '../../../whistler-api.service';

@Component({
    selector: 'app-permissions',
    templateUrl: './permissions.component.html',
    styleUrls: ['../roles/roles.component.scss']
})
export class PermissionsComponent implements OnInit {
    isLoadingResults = true;
    error = false;

    dataSource = new MatTableDataSource<Permission>();
    displayedColumns = ['Name'];

    constructor(
        private readonly whistlerAPIService: WhistlerAPIService,
    ) {
    }

    async ngOnInit(): Promise<void> {
        try {
            this.isLoadingResults = true;
            this.dataSource.data = (await this.whistlerAPIService.getPermissionList()).data;
        } catch (e) {
            this.error = true;
        } finally {
            this.isLoadingResults = false;
        }
    }

}
